import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';
import CrudBase from "src/components/CrudBase";
import Role from 'src/models/role';
import RolesForm from "./RolesForm";

export function Roles() {
    return (
        <CrudBase<Role>
            resource="roles"
            indexColumns={['name', 'description']}
            showModalColumns={['name', 'description', 'created_at', 'updated_at']}
            Form={RolesForm}
            deleteButton={false}
            searchInput={true}
            Icon={VerifiedUserIcon} />
    );
}
